module.exports = __webpack_public_path__ + "static/img/car.7e6a5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/car.png
// module id = eu9N
// module chunks = 1